/**
 * CMCD response mode variable name.
 *
 *
 * @beta
 */
export const CMCD_RESPONSE_MODE = 'response'
